// PlanPopup.jsx — the plan chooser, opened on its own.
//
// Braeden 2026-09-06: "when you click on the get more usage it needs to pop up
// the normal both options to choose from, like the plans, dont we have a pop
// up for that already"
//
// Same cards, same chrome, same CSS as the one he already knows from signup
// (`.account-modal__backdrop` > `.plan-fullscreen` > `.plan-cols` > `.pcol`) —
// the cards themselves come from planCatalog so there is one copy of what a
// plan says. What differs is the WIRING, because this opens for someone who
// already has an account:
//
//   signup's version   Continue → choosePlan() → records signup consent and
//                      finalises the pending session from the wizard
//   this one           Pro  → 'aria-open-checkout', the one payment popup
//                      Free → nothing to buy; sign them up if they have no
//                             account yet, otherwise just close
//
// Two options, not three: 2026-09-04, "there needs to eb two options right now,
// a free one and one for 20$ a month thats IT", and creditsService.getPlans()
// returns exactly those two. Ultra stays in the catalog for the signup wizard.

import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { PlanColumns, PLAN_PRICE_LABEL } from './planCatalog';

export default function PlanPopup({ onClose, currentKey = 'free', signedUp = true }) {
  // Preselect the upgrade — they arrived by pressing "Get more usage", so the
  // paid column is the answer to the question they asked.
  const [selected, setSelected] = useState('pro');

  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onClose && onClose(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [onClose]);

  const go = () => {
    if (selected === 'pro') {
      if (onClose) onClose();
      try { window.dispatchEvent(new CustomEvent('aria-open-checkout', { detail: { plan: 'subscription' } })); } catch (_) {}
      return;
    }
    // Free. An account IS the upgrade for someone who hasn't made one ($1 a
    // week as a stranger, $5 with an account); for anyone already on free
    // there is nothing to do but close.
    if (onClose) onClose();
    if (!signedUp) {
      try { window.dispatchEvent(new CustomEvent('aria-open-signin', { detail: { mode: 'signup', from: 'usage-meter' } })); } catch (_) {}
    }
  };

  const ctaLabel = selected === 'free'
    ? (signedUp ? "Stay on Free" : 'Create a free account')
    : `Continue — HowTo Pro · ${PLAN_PRICE_LABEL.pro}`;

  return createPortal(
    <div className="account-modal__backdrop" onClick={() => onClose && onClose()}>
      <div className="plan-fullscreen" onClick={(e) => e.stopPropagation()} role="dialog" aria-label="Plans">
        <button type="button" className="plan-fullscreen__close" onClick={() => onClose && onClose()} aria-label="Close">
          <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" /></svg>
        </button>

        <div className="plan-fullscreen__head">
          <div className="account-modal__brand">HowTo</div>
          <h2 className="plan-fullscreen__title">Pick how you want to run</h2>
          <p className="plan-fullscreen__sub">
            {signedUp
              ? 'Change your plan any time in Settings.'
              : 'An account gets you five times the free usage. Change your plan any time in Settings.'}
          </p>
        </div>

        <PlanColumns
          keys={['free', 'pro']}
          selected={selected}
          onSelect={setSelected}
          currentKey={signedUp ? currentKey : null}
        />

        <div className="plan-fullscreen__foot">
          <button type="button" className="account-modal__submit plan-fullscreen__cta" onClick={go}>
            {ctaLabel}
          </button>
          <p className="plan-fullscreen__terms">
            Free trains Aria on your data; paid plans are private. By continuing you agree to the{' '}
            <a href="/terms" target="_blank" rel="noopener noreferrer">Terms</a> &amp;{' '}
            <a href="/privacy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>.
          </p>
        </div>
      </div>
    </div>,
    document.body
  );
}
